/**
 * Small helpers around the DocumentTranslationLanguage enum.
 *
 * The enum keys are human-readable names ("Spanish"); the values are
 * the 2-letter codes used by the API ("ES"). The modal needs to look
 * both directions, so we memoise the inverse map once per module.
 */

import { DocumentTranslationLanguage } from '@utils/types/shared.ts';

export interface LanguageOption {
  /** 2-letter code (upper-case). */
  code: string;
  /** Human-readable name. */
  name: string;
}

const BY_CODE = new Map<string, string>();
const ALL_OPTIONS: LanguageOption[] = [];

for (const [name, code] of Object.entries(DocumentTranslationLanguage)) {
  BY_CODE.set(code, name);
  ALL_OPTIONS.push({ code, name });
}
ALL_OPTIONS.sort((a, b) => a.name.localeCompare(b.name));

export function nameForCode(code: string | null | undefined): string {
  if (!code) return '';
  return BY_CODE.get(code.toUpperCase()) ?? code.toUpperCase();
}

export function allLanguages(): LanguageOption[] {
  return ALL_OPTIONS;
}
